exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prebuild-stars .vue-star-rating .vue-star-rating-star {\n  margin: 0;\n}", ""]);

// exports
